import type { CollectionType } from '@/store/collection/types';

const collectionApi = {
  collection: {
    commentCollection: '/api/collections/items/comment',
    my: '/api/collections/my',
    myUnavailable: '/api/collections/my/unavailable',
    contains: '/api/collections/contains',
    addOrRemove: '/api/collections/items',

    collectionListByType: (type: CollectionType) => `/api/collections/${ type }`,
    detailCollection: (id: number, type: CollectionType) => `/api/collections/${ type }/${ id }`,

    unViewedCollectionStatus: '/api/collections/manager/unviewed-status',
    viewedCollection: '/api/collections/manager/viewed',

    managerRequest: (bookingId: number) => `/api/collections/request/${ bookingId }`,
  },
};

export default collectionApi;

export const collectionApiConfig = collectionApi.collection;
